// @flow
import React from 'react'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/reset.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/site.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/segment.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/container.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/header.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/image.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/list.css'
import { hot } from 'react-hot-loader/root'
import './styles.scss'
import { LifeStep } from 'components/lifestep'
import { Tracking, Image } from 'components/contentbricks'

import ArticleTeasers from '@ta-interaktiv/react-article-teasers'
import Masthead from '@ta-interaktiv/react-masthead'
import { Footer } from '@ta-interaktiv/react-footer'
import ThemeSwitch from '@ta-interaktiv/react-theme-switch'

// TODO Set the correct article ID here
const ARTICLE_ID = '10139611'

function AppComponent() {
  return (
    <div className='index'>
      <Masthead articleId={ARTICLE_ID} />
      <ThemeSwitch />

      <header className='ui vertical very relaxed segment'>
        <div className='ui container'>
          <h1 className='ui image header'>
            <div className='content'>
              Une vie entière de portante
              <br />
              pour finir en&nbsp;&nbsp;
              <img
                src={require('images/wurst.png')}
                width='180px'
                aria-label='Wurst'
                style={{ display: 'inline-block', verticalAlign: 'text-top' }}
              />
              <div className='sub header'>
                De la naissance à la mort: les hauts et les bas de la vie de
                vache en Suisse.
              </div>
            </div>
          </h1>
        </div>
      </header>

      <LifeStep
        title=''
        image='main_illu_1.svg'
        time='Naissance'
        text='step1.mdx'
        cssClass='first'
      />

      <LifeStep
        title=''
        image='main_illu_2.svg'
        time='Les premiers jours'
        text='step2.mdx'
      />
      <LifeStep
        title=''
        image='main_illu_3.svg'
        time='Trois semaines après'
        text='step2.5.mdx'
      />
      <Tracking label='content25' />

      <LifeStep
        title=''
        time='Six mois après'
        image='main_illu_5.svg'
        text='step3.mdx'
      />

      <LifeStep
        title=''
        image='main_illu_4.svg'
        time='Sept mois après'
        text='step4.mdx'
      />
      <Tracking label='content50' />
      <LifeStep
        title=''
        time='Un an et demi après'
        image='main_illu_7.svg'
        text='step5.mdx'
      />
      <LifeStep
        title=''
        time='Deux ans et demi après'
        image='main_illu_9.svg'
        text='step6.mdx'
      />
      <Tracking label='content75' />

      <LifeStep
        title=''
        image='main_illu_8.svg'
        time='Trois ans et demi après'
        text='step7.mdx'
      />
      <LifeStep
        title=''
        image='main_illu_11.svg'
        time='Quatre ans et demi après'
        text='step8.mdx'
      />

      <LifeStep
        title=''
        time='Cinq ans après'
        image='main_illu_12.svg'
        text='step9.mdx'
        cssClass='last'
      />
      <div className='ui vertical segment schlachthof'>
        <div className='ui container' style={{ textAlign: 'center' }}>
          <Image
            file={['schlachthof-fr-01.png', 'schlachthof-fr-02.png']}
            title=''
            subtitle=' '
          />
        </div>
      </div>

      <Footer
        mailTo={'24heures.web@24heures.ch'}
        locale={'fr'}
        articleId={ARTICLE_ID}
        hidePortfolioTeaser
        credits={[
          [
            'Concept, illustrations et réalisation',
            'Sebastian Broschinski et Marc Brupbacher'
          ],
          ['Texte et Recherche', 'Catherine Boss et Sven Cornehls'],
          ['Traduction', 'Laurent Duvanel'],
          [
            'Données',
            'Agrarbericht 2018, BLV, BLW, European Commision, KAGfreiland, Land schafft Leben, Der Landbote, Muttterkuh Schweiz, myclimate, Proviande, Schweizer Bauer, Schweizer Kälbermäster-Verband (SKMV), SRF, Swissinfo, Swissmilk, Swissveg, Tages-Anzeiger, TVD Tierverkehrsdatenbank Identitas AG, US Department of Agriculture,  WBF'
          ]
        ]}
      >
        {/* Agrarbericht 2018 agrarbericht.ch
BLV blv.admin.ch
BLW blw.admin.ch
European Commision ec.europa.eu
KAGfreiland kagfreiland.ch
Land schafft Leben landschaftleben.at
Der Landbote landbote.ch
Muttterkuh Schweiz mutterkuh.ch
myclimate myclimate.org
Proviande proviande.ch
Schweizer Bauer schweizerbauer.ch
Schweizer Kälbermäster-Verband (SKMV) kaelbermaester.ch
SRF srf.ch
Swissinfo swissinfo.ch
Swissmilk swissmilk.ch
Swissveg swissveg.ch
Tages-Anzeiger tagesanzeiger.ch
TVD Tierverkehrsdatenbank Identitas AG identitas.ch
US Department of Agriculture ers.usda.gov
WBF wbf.admin.ch */}

        <div className='ui vertical segment'>
          <div className='ui container'>
            <ArticleTeasers
              articleIds={[
                '12635375',
                '29424846',
                '21613709',
                '18030699',
                '13798366',
                '11422943'
              ]}
              numberOfCards='three'
            />
          </div>
        </div>
      </Footer>
    </div>
  )
}

export default hot(AppComponent)
